import React, { useState } from "react";
import {
  View,
  Text,
  TouchableOpacity,
  Dimensions,
  Linking,
} from "react-native";
import ModalFilterPicker from "react-native-modal-filter-picker";
import i18n from "@microdoing/shared/i18n";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";
import Colors from "@microdoing/shared/constants/Colors";
import { DateBox } from "../../components/common";
import { useSelector } from "react-redux";
import { getLanguage } from "@microdoing/shared/services/profileSettings/selectors";
import theme from "app/Theme/Theme";

const { width, height } = Dimensions.get("window");

const options = [
  {
    key: "INTJ",
    label: "INTJ",
    // label: i18n.t("INTJ-description")
  },
  {
    key: "INTP",
    // label: i18n.t("INTP-description")
    label: "INTP",
  },
  {
    key: "ENTJ",
    // label: i18n.t("INTJ-description")
    label: "ENTJ",
  },
  {
    key: "ENTP",
    // label: i18n.t("INTP-description")
    label: "ENTP",
  },
  {
    key: "INFJ",
    label: "INFJ",
  },
  {
    key: "INFP",
    label: "INFP",
  },
  {
    key: "ENFJ",
    label: "ENFJ",
  },
  {
    key: "ENFP",
    label: "ENFP",
  },
  {
    key: "ISTJ",
    label: "ISTJ",
  },
  {
    key: "ISFJ",
    label: "ISFJ",
  },
  {
    key: "ESTJ",
    label: "ESTJ",
  },
  {
    key: "ESFJ",
    label: "ESFJ",
  },
  {
    key: "ISTP",
    label: "ISTP",
  },
  {
    key: "ISFP",
    label: "ISFP",
  },
  {
    key: "ESTP",
    label: "ESTP",
  },
  {
    key: "ESFP",
    description:
      "Amuseurs spontanés, énergiques et enthousiastes; avec eux, on ne s’ennuie jamais.",
    label: "ESFP",
  },
];

const MbtiSelector = ({ onSelectOption, selectedOption, roundStyle }) => {
  const [isVisible, setVisibility] = useState(false);
  const language = useSelector(getLanguage);

  const onSelect = option => {
    onSelectOption(option.key);
    setVisibility(false);
  };

  const onCancel = () => {
    setVisibility(false);
  };

  const onShow = () => {
    setVisibility(true);
  };

  const openMbti = () => {
    if (language === "fr") {
      Linking.openURL(
        "https://www.16personalities.com/fr/test-de-personnalite",
      );
    } else {
      Linking.openURL("https://www.16personalities.com/free-personality-test");
    }
  };

  const displayInput = () => {
    if (roundStyle) {
      return (
        <TouchableOpacity onPress={onShow}>
          <DateBox value={selectedOption} placeholder={i18n.t("mbti-score")} />
          <Text style={[styles.info, styles.signupInfo]}>
            {i18n.t("mbti-optional")}
          </Text>
        </TouchableOpacity>
      );
    }
    return (
      <View style={styles.container}>
        <TouchableOpacity onPress={onShow}>
          <Text
            style={[styles.title, selectedOption && { color: Colors.green }]}
          >
            {selectedOption
              ? `${i18n.t("mbti-score")} ✓`
              : i18n.t("mbti-score")}
          </Text>
        </TouchableOpacity>
        <Text style={styles.info}>
          {i18n.t("no-mbti-yet")}
          <Text onPress={openMbti} style={styles.link}>
            {i18n.t("discover-mbti")}
          </Text>
        </Text>
        <TouchableOpacity
          onPress={onShow}
          style={{
            borderBottomWidth: 1,
            marginLeft: 15,
            borderColor: theme.colors["neutral.100"],
            width: wp("92%"),
          }}
        >
          <Text style={[styles.input, selectedOption && styles.selected]}>
            {selectedOption || i18n.t("your-mbti-score")}
          </Text>
        </TouchableOpacity>
      </View>
    );
  };
  return (
    <View>
      <ModalFilterPicker
        keyboardShouldPersistTaps="always"
        selectedOption={selectedOption}
        listContainerStyle={styles.listContainerStyle}
        visible={isVisible}
        onSelect={onSelect}
        onCancel={onCancel}
        options={options}
      />
      {displayInput()}
    </View>
  );
};

const styles = {
  title: {
    width,
    fontSize: wp("4%"),
    color: theme.colors["neutral.500"],
    marginTop: 15,
    marginLeft: 15,
    marginBottom: 5,
  },
  listContainerStyle: {
    borderRadius: 8,
    flex: 1,
    width: width * 0.8,
    maxHeight: height * 0.7,
    backgroundColor: theme.colors["neutral.white"],
    marginBottom: 15,
  },
  input: {
    marginRight: 15,
    fontSize: wp("4%"),
    color: theme.colors["neutral.400"],
    paddingBottom: 2,
  },
  selected: {
    marginRight: 15,
    color: theme.colors["neutral.900"],
  },
  link: {
    color: Colors.blue,
    textDecorationLine: "underline",
  },
  info: {
    flexWrap: "wrap",
    marginLeft: 16,
    marginRight: 10,
    marginBottom: 5,
    fontSize: 12,
  },
  signupInfo: {
    marginBottom: 5,
    marginTop: 5,
    fontSize: 12,
    width: wp("75%"),
    alignSelf: "center",
    textAlign: "center",
    color: theme.colors["neutral.white"],
  },
};

export default MbtiSelector;
